"use strict";

import { commonConstants } from "../_constants";

export const INITIAL_USER_STATE = {
    uploadImage: null
};

export function common(state = INITIAL_USER_STATE, action) {
    switch (action.type) {
        case commonConstants.IMAGE_UPLOAD_COMPLETE:
            return {
                ...state,
                uploadImage: action.payload ,
            };
    }
    return state;
}